import React from "react";
import "./Header.css";

const Header: React.FC = () => {
  return (
    <div className="header">
      <h1>PLEX Journey Planner</h1>
    </div>
  );
};

export default Header;
